// extracted by mini-css-extract-plugin
module.exports = {"container":"climbing-height_container_mp2YH","noDataBox":"climbing-height_noDataBox_31Uwd","icon":"climbing-height_icon_1sV6H","chartBox":"climbing-height_chartBox_qhAC1"};